import { TranslationMessages } from 'react-admin';
import englishMessages from 'ra-language-english';

const customEnglishMessages: TranslationMessages = {
    ...englishMessages,
    ra: {
        ...englishMessages.ra,
        auth: {
            ...englishMessages.ra.auth,
            username: 'Email',
        },
    },
    pos: {
        search: 'Search',
        configuration: 'Configuration',
        language: 'Language',
        theme: {
            name: 'Theme',
            light: 'Light',
            dark: 'Dark',
        },
        dashboard: {
            monthly_revenue: 'Monthly Revenue',
            month_history: '30 Day Revenue History',
            new_orders: 'New Orders',
            pending_reviews: 'Pending Reviews',
            pending_validations: 'Pending Validations',
            pending_postings: 'Pending FBR Postings',
            all_reviews: 'See all reviews',
            new_customers: 'New Customers',
            all_customers: 'See all customers',
            pending_orders: 'Pending Orders',
            order: {
                items: 'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
            },
            welcome: {
                title: 'Welcome to the react-admin e-commerce demo',
                subtitle:
                    "This is the admin of an imaginary poster shop. Feel free to explore and modify the data - it's local to your computer, and will reset each time you reload.",
                ra_button: 'react-admin site',
                demo_button: 'Source for this demo',
            },
        },
        menu: {
            sales: 'Sales',
            catalog: 'Catalog',
            customers: 'Customers',
        },
        events: {
            review: {
                title: 'Posted review on "%{product}"',
            },
            order: {
                title: 'Ordered 1 poster |||| Ordered %{smart_count} posters',
            },
        },
    },
    shell: {
        accounting: {
            dashboard: 'Dashboard',
            customers: 'Customers',
            vendors: 'Vendors',
            transaction: 'Transaction',
            transaction_vendor_bills: 'Vendor Bills',
            transaction_payments: 'Payments',
            transaction_receipts: 'Receipts',
            bills: 'Bills',
            bills_empty:
                'No vendor bills yet. Create one to record a payable and post it to the general ledger.',
            bills_col_label: 'Label',
            bills_col_account: 'Account',
            bills_col_quantity: 'Quantity',
            bills_col_price: 'Price',
            bills_col_taxes: 'Taxes',
            bills_col_amount: 'Amount',
            bills_col_project: 'Project',
            bills_col_wbs: 'WBS',
            bills_col_task: 'Task',
            bills_project: 'Project',
            bills_col_number: 'Number',
            bills_col_vendor: 'Vendor',
            bills_col_reference: 'Bill Reference',
            bills_col_bill_date: 'Bill Date',
            bills_col_due_date: 'Due Date',
            bills_col_total: 'Total',
            bills_col_amount_due: 'Amount Due',
            bills_col_status: 'Status',
            bills_untaxed_amount: 'Untaxed Amount',
            bills_tax_total: 'Tax',
            bills_total: 'Total',
            bank_payments: 'Bank Payments',
            cash_payments: 'Cash Payments',
            bank_receipts: 'Bank Receipts',
            cash_receipts: 'Cash Receipts',
            bank_information: 'Bank Information',
            bank_information_subtitle: 'Bank accounts and linked chart postings.',
            bank_chart_section: 'New Chart Account (Bank & Cash)',
            bank_account_new: 'New Bank Account',
            bank_account_edit: 'Edit Bank Account',
            gen_bank_information_empty:
                'No bank accounts yet. Create one to link postings to a bank GL account.',
            gen_bank_filters_placeholder:
                'Use the search box to find banks by title or details. More filters can be added later.',
            cash_information: 'Cash Information',
            cash_information_subtitle: 'Cash boxes and linked chart postings.',
            cash_chart_section: 'New Chart Account (Bank & Cash)',
            gen_cash_information_empty:
                'No cash accounts yet. Create one to link postings to a cash GL account.',
            gen_cash_filters_placeholder:
                'Use the search box to find cash accounts by title. More filters can be added later.',
            voucher_types_configuration: 'Voucher types',
            no_access_transactions: 'You do not have access to transaction vouchers.',
            accounting: 'Accounting',
            journal_vouchers: 'Journal Vouchers',
            vouchers_log_book: 'Vouchers Log book',
            review: 'Review',
            reporting: 'Reporting',
            configuration: 'Configuration',
            accounting_section: 'Accounting',
            chart_of_accounts: 'Chart of Accounts',
            voucher_types: 'Voucher Types',
            no_access_voucher_types: 'You do not have access to voucher types.',
            voucher_types_empty:
                'No voucher types for this company yet. Load a starter set or create one manually.',
            load_default_voucher_types: 'Load default voucher types',
            voucher_types_seeded: 'Default voucher types loaded.',
            company: 'Company',
            accounting_information: 'Accounting information',
            control_section: 'Control',
            voucher_type_save_hint: 'Voucher templates for postings (cash, bank, journal, etc.).',
            voucher_title_placeholder: 'e.g. Customer invoices',
            coming_soon: 'Coming soon',
            import_label: 'Import',
            import_records: 'Import records',
            export_all: 'Export all',
            download_import_template: 'Download CSV template',
            chart_import_done: 'Import finished',
            chart_import_summary:
                'Created: %{created} · Updated: %{updated} · Skipped: %{skipped}',
            new_soon: 'Record creation will be available in a later update.',
            choose_columns: 'Choose columns',
            no_access_chart: 'You do not have access to the chart of accounts.',
            ledgers_section: 'Ledgers',
            trial_balance: 'Trial balance',
            general_ledger: 'General ledger',
            gl_opened_for_party:
                'Opened from vendor — partner id %{id}. Partner column is turned on below for line detail.',
            date_from: 'From',
            date_to: 'To',
            posted_only: 'Posted entries only',
            trial_balance_unposted_banner:
                'There are unposted journal entries on or within this period.',
            tb_col_account: 'Account',
            tb_group_initial: 'Opening Balance',
            tb_group_end: 'End balance',
            tb_col_balance: 'Balance',
            tb_col_debit: 'Debit',
            tb_col_credit: 'Credit',
            tb_hide_zero_balances: 'Hide zero balances',
            tb_export_pdf: 'Export PDF',
            tb_export_excel: 'Export Excel',
            tb_filter_all: 'All',
            tb_period_activity: 'Period activity',
            gl_preset_month: 'This month',
            gl_preset_quarter: 'This quarter',
            gl_preset_year: 'This year',
            gl_preset_custom: 'Custom',
            gl_col_balance_end: 'Balance',
            gl_col_balance_run: 'Balance',
            gl_col_type: 'Type',
            gl_col_v_no: 'V No',
            gl_col_date: 'Date',
            gl_col_narration: 'Narration',
            gl_col_partner: 'Partner',
            gl_col_scheme: 'Scheme',
            gl_opening_balance: 'Opening balance',
            gl_optional_columns: 'Optional columns',
            gl_search_placeholder: 'Search account code or name…',
            gl_include_zero_closing: 'Include zero closing balance',
            gl_export_pdf: 'Export PDF',
            gl_export_excel: 'Export Excel',
            gl_single_account_export_hint: 'One account matches — export full ledger:',
            general_ledger_coming_soon: 'General ledger report is coming soon.',
        },
        settings: {
            security_groups: 'Security groups',
            security_group_create_title: 'New Security Group',
            record_rule_fields: 'Record rule fields (which columns to use)',
        },
        recordThread: {
            save_first: 'Save the record once to enable notes and the activity log.',
            notes_title: 'Internal notes',
            notes_hint:
                'Notes and attachments are stored with this record. Type @ in the note to mention someone.',
            notes_hint_dms:
                'Notes stay with this record; attachments are filed in Document Management. Type @ in the note to mention someone.',
            note_placeholder: 'Write an internal note…',
            attach: 'Attach',
            post: 'Post',
            timeline_empty: 'No activity yet.',
            profile_loading: 'Loading…',
            profile_email: 'Email',
            profile_username: 'Username',
            profile_phone: 'Phone',
            profile_unavailable: 'Profile unavailable.',
            system_audit_no_detail: 'Record updated',
        },
    },
    resources: {
        customers: {
            name: 'Customer |||| Customers',
            fields: {
                orders: 'Orders',
                first_seen: 'First seen',
                full_name: 'Name',
                groups: 'Segments',
                last_seen: 'Last seen',
                last_seen_gte: 'Visited Since',
                name: 'Name',
                total_spent: 'Total spent',
                password: 'Password',
                confirm_password: 'Confirm password',
                stateAbbr: 'State',
            },
            filters: {
                last_visited: 'Last visited',
                today: 'Today',
                this_week: 'This week',
                last_week: 'Last week',
                this_month: 'This month',
                last_month: 'Last month',
                earlier: 'Earlier',
                has_ordered: 'Has ordered',
                has_newsletter: 'Has newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identity',
                address: 'Address',
                stats: 'Stats',
                history: 'History',
                password: 'Password',
                change_password: 'Change Password',
            },
            page: {
                delete: 'Delete Customer',
            },
            errors: {
                password_mismatch:
                    'The password confirmation is not the same as the password.',
            },
            notifications: {
                created:
                    'Customer created |||| %{smart_count} customers created',
                updated:
                    'Customer updated |||| %{smart_count} customers updated',
                deleted:
                    'Customer deleted |||| %{smart_count} customers deleted',
            },
        },
        vendors: {
            name: 'Vendor |||| Vendors',
            delete_confirm: 'Delete this vendor?',
            delete_success: 'Vendor deleted',
            page_titles: {
                create: 'New Vendor',
                edit: 'Vendor',
            },
            fields: {
                party_type: 'Type',
                party_name: 'Vendor name',
                email: 'Email',
                phone: 'Phone',
                street: 'Street',
                street2: 'Street 2',
                city: 'City',
                state: 'State / Province',
                country_hint: 'ZIP / Country',
                ntn: 'NTN',
                website: 'Website',
                tags: 'Tags',
                geo: 'Latitude / Longitude',
                contact_person: 'Contact person',
                contact_mobile: 'Contact mobile',
                contact_email: 'Contact email',
                fax: 'Fax',
                phone_two: 'Phone 2',
                business_name: 'Business name',
                stn: 'STN',
                cnic: 'CNIC',
                terms: 'Terms & conditions',
                credit_limit: 'Credit limit',
                currency_id: 'Currency ID',
                payment_term: 'Payment term ID',
                remarks: 'Remarks',
                salesman_id: 'Salesman ID',
                sector_id: 'Sector ID',
                gl_type: 'GL type',
                partner_limit: 'Partner limit',
            },
            choices: {
                company: 'Company',
                person: 'Person',
            },
            placeholders: {
                party_name: 'e.g. Lumber Inc',
            },
            hints: {
                zip_country: 'Use city / remarks if needed — not separate columns on gen_PartiesInfo.',
                website: 'Not stored on gen_PartiesInfo in this build.',
                tags: 'Placeholder',
                geo: 'No columns on gen_PartiesInfo',
            },
            accounting: {
                general: 'General',
                bank_accounts_hint: 'Bank accounts: link from your ERP when available.',
                account_payable: 'Account payable (GL)',
                ar_ap_note: 'gen_PartiesInfo has a single PartyGLID; receivable is not a separate column.',
                followups: 'Invoice follow-ups',
                odoo_only: 'Peppol, reminders, and DSO are not on gen_PartiesInfo — UI placeholder.',
                credit_limits: 'Credit limits',
                total_receivable_placeholder: 'Total receivable / DSO: not persisted here.',
                partner_limit_hint: 'Partner limit uses Credit limit (left).',
            },
            tabs: {
                partner_assignment_placeholder:
                    'Assign salespeople / routes when linked to your ERP tables.',
                dis_hierarchy_placeholder: 'Distribution hierarchy — connect to ERP when available.',
            },
        },
        orders: {
            name: 'Order |||| Orders',
            amount: '1 order |||| %{smart_count} orders',
            title: 'Order %{reference}',
            fields: {
                basket: {
                    delivery: 'Delivery',
                    reference: 'Reference',
                    quantity: 'Quantity',
                    sum: 'Sum',
                    tax_rate: 'Tax Rate',
                    taxes: 'Tax',
                    total: 'Total',
                    unit_price: 'Unit Price',
                },
                address: 'Address',
                customer_id: 'Customer',
                date_gte: 'Passed Since',
                date_lte: 'Passed Before',
                nb_items: 'Nb Items',
                total_gte: 'Min amount',
                status: 'Status',
                returned: 'Returned',
            },
            section: {
                order: 'Order',
                customer: 'Customer',
                shipping_address: 'Shipping Address',
                items: 'Items',
                total: 'Totals',
            },
            invoice: {
                document: 'Invoice',
                invoice_date: 'Invoice Date',
                payment_terms: 'Payment Terms',
                reference: 'Reference',
                line_items: 'Order Lines',
                columns: 'Columns',
                optional_columns: 'Optional Columns',
                hs_code: 'HS Code',
                sro_number: 'SRO Number',
                sro_schedule_no: 'SRO Schedule No',
                sro_item: 'SRO Item',
                fbr_sale_type: 'FBR Sale Type',
                discount_pct: 'Discount %',
                tax_amount: 'Tax Amount',
                gross_amount: 'Gross Amount',
                remarks: 'Remarks',
                sale_rate: 'Sale Rate',
                net_amount: 'Net Amount',
                add_a_line: 'Add a Line',
                chatter: {
                    title: 'Chatter',
                    hint: 'Log notes, attach files, and track activity (stored in this browser).',
                    placeholder: 'Log an internal note…',
                    attach: 'Attach',
                    post: 'Post',
                    empty: 'No messages yet.',
                },
            },
            notifications: {
                created: 'Order created |||| %{smart_count} orders created',
                updated: 'Order updated |||| %{smart_count} orders updated',
                deleted: 'Order deleted |||| %{smart_count} orders deleted',
            },
        },
        fbrInvoices: {
            name: 'FBR Invoice |||| FBR Invoices',
            create_title: 'Create Invoice',
            new_invoice_title: 'New Invoice',
            reference_after_save: 'Assigned automatically when you save.',
            chatter_after_save:
                'Save the invoice once to enable chatter and attachments.',
            chatter: {
                stored_on_server: 'Notes and attachments are saved on the server with this invoice.',
            },
        },
        salesServiceInfo: {
            name: 'Sales Service Information |||| Sales Service Information',
        },
        colorInfo: {
            name: 'Color Info |||| Colors Info',
            document: 'Color',
            subtitle: 'All changes are saved on the server.',
            create_title: 'Create Color Information',
            new_invoice_title: 'New Color Information',
            reference_after_save: 'Assigned automatically when you save.',
            chatter_after_save:
                'Save the color information once to enable chatter and attachments.',
            chatter: {
                stored_on_server: 'Notes and attachments are saved on the server with this color information.',
            },
        },
        fbrScenarios: {
            name: 'FBR Scenario |||| FBR Scenarios',
            document: 'Scenario',
            new_title: 'New Scenario',
            header_create: 'Scenario',
            subheader_hint: 'All changes are saved on the server.',
            fields: {
                scenario_code: 'Scenario code',
                description: 'Description',
                pdi_trans_type_id: 'PDI transaction type id',
            },
        },
        fbrSalesTaxRates: {
            name: 'Tax |||| Taxes',
            document: 'Tax',
            new_title: 'New Tax',
            header_create: 'Tax',
            subheader_hint: 'All changes are saved on the server.',
            section: {
                definition: 'Tax definition',
            },
            fields: {
                tax_name: 'Tax name',
                tax_computation: 'Tax computation',
                active: 'Active',
                tax_type: 'Tax type',
                tax_scope: 'Tax scope',
                amount_percent: 'Amount (%)',
                effective_from: 'Effective from',
                effective_to: 'Effective to',
                label_on_invoices: 'Label on invoices',
                description: 'Description',
                tax_group: 'Tax group',
                include_in_analytic_cost: 'Include in analytic cost?',
                company: 'Company',
                country: 'Country',
                legal_notes: 'Legal notes',
                included_in_price: 'Included in price?',
                affect_base_subsequent: 'Affect base of subsequent taxes?',
            },
            tab: {
                definition: 'Definition',
                advanced: 'Advanced options',
            },
            chatter_after_save:
                'Save the tax rate once to enable chatter and attachments.',
            chatter: {
                stored_on_server:
                    'Notes and attachments are saved on the server with this tax rate.',
            },
        },
        glChartAccounts: {
            name: 'Chart of Account |||| Chart of Accounts',
            fields: {
                gl_code: 'Code',
                gl_title: 'Account Name',
                type_label: 'Type',
                allow_reconciliation: 'Allow Reconciliation',
                account_currency: 'Account Currency',
                companies: 'Companies',
            },
        },
        genBankInformation: {
            name: 'Bank Information |||| Bank Information',
            new_gl_hint:
                'Enter the chart code and name for this bank’s ledger account (Bank & Cash, type 9). It is created when you save.',
            cheque_books_hint:
                'Only one cheque book can be active per bank. “Used” reflects bank payments that reference this GL account’s cheque number.',
            view_serials: 'View cheque numbers',
            save_bank_first_serials: 'Save the bank once to view serial status.',
            add_cheque_book: 'Add cheque book',
            serial_dialog_title: 'Cheque numbers in this book',
            fields: {
                bank_account_title: 'Account title',
                bank_account_number: 'Account number',
                bank_name: 'Bank name',
                bank_branch_code: 'Branch code',
                bank_address: 'Bank address',
                new_gl_code: 'Chart code',
                new_gl_title: 'Chart name',
                validate_cheque_book: 'Validate cheque book on bank payments',
                serial_start: 'Start serial',
                serial_end: 'End serial',
                active: 'Active',
                cheque_no: 'Cheque no.',
                status: 'Status',
            },
            validate_cheque_book_help:
                'When enabled, bank payments must use a cheque number from the active book (manual numbers are checked against that range).',
            actions: {
                mark_cancelled: 'Mark cancelled',
                cancel_serial: 'Cancel',
            },
        },
        genCashInformation: {
            name: 'Cash Information |||| Cash Information',
            new_gl_hint:
                'A GL account is created for this cash box; its id is stored as the linked cash chart account.',
            cash_readonly_hint:
                'Set when this cash account was created; links postings to the chart account.',
            fields: {
                account_title: 'Title',
                cash_account: 'Cash GL account',
                branch_id: 'Branch',
                new_gl_code: 'Chart code',
                new_gl_title: 'Chart name',
            },
        },
        glVoucherTypes: {
            name: 'Voucher type |||| Voucher types',
            yes: 'Yes',
            no: 'No',
            debit: 'Debit',
            credit: 'Credit',
            default_accounts_section: 'Default accounts',
            tab_custom_signatures: 'Custom Signatures',
            signature_count: 'No. of signatures',
            signature_line_n: 'Signature line %{n}',
            prefix_placeholder: 'e.g. INV, BNK, ABC',
            help: {
                system_type:
                    'Determines the nature of this voucher when posting (cash, bank, sales, etc.).',
                prefix_on_documents:
                    'Used as a prefix on vouchers when they are created or printed (e.g. invoice or voucher numbers).',
                company:
                    'When you use more than one company, this voucher type applies only to the company shown here.',
                currency:
                    'Reserved for a later release: will control transactions based on this voucher type’s base currency.',
            },
            fields: {
                title: 'Title',
                description: 'Description',
                system_type: 'Type',
                prefix_on_documents: 'Prefix on documents',
                currency: 'Currency',
                status: 'Active',
                entry_by_audit: 'Last saved by',
                default_control_account: 'Default control account',
                control_txn_nature: 'Control account transaction nature',
                default_income_account: 'Default income account',
                show_bank_and_cheque_date: 'Show bank and cheque date',
                show_to_party: 'Show to party',
                inter_transfer_policy: 'Inter-transfer policy',
                show_to_account_book: 'Show to account book',
                status_active: 'Status (active)',
            },
        },
        glJournalVouchers: {
            name: 'Journal Voucher |||| Journal Vouchers',
            title: 'Journal Voucher',
            title_one: 'Journal Voucher',
            create_title: 'New Journal Voucher',
            create_bank_payment: 'New Bank Payment',
            create_cash_payment: 'New Cash Payment',
            create_bank_receipt: 'New Bank Receipt',
            create_cash_receipt: 'New Cash Receipt',
            document_label: 'Journal Voucher',
            subtitle: 'All Changes Are Saved On The Server.',
            optional_columns: 'Optional columns',
            columns_menu: 'Columns',
            lines_title: 'Journal Lines',
            add_line: 'Add a line',
            no_lines: 'No lines yet.',
            totals: 'Totals',
            imbalance_warning: 'Debit and credit totals must match before posting.',
            posted_ok: 'Voucher posted.',
            notifications: {
                approved_ok: 'Voucher approved.',
                confirmed_ok: 'Voucher confirmed.',
                void_ok: 'Voucher voided.',
            },
            status: {
                draft: 'Draft',
                posted: 'Posted',
            },
            workflow: {
                draft: 'Draft',
                approved: 'Approved',
                confirmed: 'Confirmed',
                posted: 'Posted',
                deleted: 'Deleted',
            },
            actions: {
                post: 'Post',
                approve: 'Approve',
                confirm: 'Confirm',
                void: 'Void',
                duplicate: 'Duplicate',
                print_pdf: 'Print PDF',
            },
            duplicate_need_type: 'Select a voucher type before duplicating.',
            duplicate_opening: 'Opened a new voucher with copied lines.',
            print_need_type: 'Select a voucher type before printing.',
            fields: {
                voucher_no: 'Number',
                voucher_date: 'Accounting Date',
                journal: 'Journal',
                voucher_type: 'Voucher Type',
                bank_cash_account: 'Bank / Cash Account',
                bank_account: 'Bank Account',
                cash_account: 'Cash Account',
                reference: 'Reference',
                cheque_no: 'Cheque No.',
                cheque_date: 'Cheque Date',
                remarks: 'Remarks',
                status: 'Status',
                total_dr: 'Debit',
                total_cr: 'Credit',
                account: 'Account',
                label: 'Label',
                narration: 'Narration',
                debit: 'Debit',
                credit: 'Credit',
                tax_amount: 'Tax',
                taxes: 'Taxes',
                partner: 'Partner',
                partner_ref: 'Partner ref',
                partner_bank: 'Partner Bank A/C',
                line_tax_amount: 'Tax amount',
            },
        },
        invoices: {
            name: 'Invoice |||| Invoices',
            fields: {
                date: 'Invoice date',
                customer_id: 'Customer',
                order_id: 'Order',
                date_gte: 'Passed Since',
                date_lte: 'Passed Before',
                total_gte: 'Min amount',
                address: 'Address',
            },
            notifications: {
                created: 'Invoice created |||| %{smart_count} invoices created',
                updated: 'Invoice updated |||| %{smart_count} invoices updated',
                deleted: 'Invoice deleted |||| %{smart_count} invoices deleted',
            },
        },
        products: {
            name: 'Poster |||| Posters',
            fields: {
                category_id: 'Category',
                height_gte: 'Min height',
                height_lte: 'Max height',
                height: 'Height',
                image: 'Image',
                price: 'Price',
                reference: 'Reference',
                sales: 'Sales',
                stock_lte: 'Low Stock',
                stock: 'Stock',
                thumbnail: 'Thumbnail',
                width_gte: 'Min width',
                width_lte: 'Max width',
                width: 'Width',
            },
            tabs: {
                image: 'Image',
                details: 'Details',
                description: 'Description',
                reviews: 'Reviews',
            },
            filters: {
                categories: 'Categories',
                stock: 'Stock',
                no_stock: 'Out of stock',
                low_stock: '1 - 9 items',
                average_stock: '10 - 49 items',
                enough_stock: '50 items & more',
                sales: 'Sales',
                best_sellers: 'Best sellers',
                average_sellers: 'Average',
                low_sellers: 'Low',
                never_sold: 'Never sold',
            },
            notifications: {
                created: 'Poster created |||| %{smart_count} posters created',
                updated: 'Poster updated |||| %{smart_count} posters updated',
                deleted: 'Poster deleted |||| %{smart_count} posters deleted',
            },
        },
        categories: {
            name: 'Category |||| Categories',
            fields: {
                products: 'Products',
            },
            notifications: {
                created:
                    'Category created |||| %{smart_count} categories created',
                updated:
                    'Category updated |||| %{smart_count} categories updated',
                deleted:
                    'Category deleted |||| %{smart_count} categories deleted',
            },
        },
        reviews: {
            name: 'Review |||| Reviews',
            amount: '1 review |||| %{smart_count} reviews',
            relative_to_poster: 'Review on poster',
            detail: 'Review detail',
            fields: {
                customer_id: 'Customer',
                order_id: 'Order',
                product_id: 'Product',
                date_gte: 'Posted since',
                date_lte: 'Posted before',
                date: 'Date',
                comment: 'Comment',
                rating: 'Rating',
            },
            action: {
                accept: 'Accept',
                reject: 'Reject',
            },
            notifications: {
                created: 'Review created |||| %{smart_count} reviews created',
                updated: 'Review updated |||| %{smart_count} reviews updated',
                deleted: 'Review deleted |||| %{smart_count} reviews deleted',
                approved_success: 'Review approved',
                approved_error: 'Error: Review not approved',
                rejected_success: 'Review rejected',
                rejected_error: 'Error: Review not rejected',
            },
        },
        users: {
            name: 'User |||| Users',
        },
        companies: {
            name: 'Company |||| Companies',
            notifications: {
                fbr_pdi_synced: 'FBR PDI reference data synced.',
            },
        },
        segments: {
            name: 'Segment |||| Segments',
            fields: {
                customers: 'Customers',
                name: 'Name',
            },
            data: {
                compulsive: 'Compulsive',
                collector: 'Collector',
                ordered_once: 'Ordered once',
                regular: 'Regular',
                returns: 'Returns',
                reviewer: 'Reviewer',
            },
        },
    },
};

export default customEnglishMessages;
